import React, { Component } from 'react';
import './App.css';
import ReactAudioPlayer from 'react-audio-player';
import SongInfo from './SongInfo';


class App extends Component {

  constructor(props){
    super(props)
    
    this.state = {
      tracks: [],
      current: 0
    }
  }

  componentDidMount(){
    fetch('https://theperfectexit.net/wp-json/sgr/v1/tracklist')
    .then(res => res.json())
    .then(
      (result) =>{
      this.setState({
        tracks: JSON.parse(result)
      });
    });
  }

  nextTrack(){
    this.setState({'current': this.state.current + 1})
  }


  render() {

    var url = '';
    var id = '';
    if (this.state.tracks[this.state.current]){
      id = this.state.tracks[this.state.current].id;
      url = this.state.tracks[this.state.current].url;
    }

    return (
      <div className="App">
        <ReactAudioPlayer
          src={url}
          autoPlay
          controls
          onEnded={() => this.nextTrack()}
        />
        <SongInfo songid={id} />
      </div>
    );
  }
}

export default App;
